import React from 'react';
import styles from './ProfessionTicker.module.css';
import headlinesLogo from '@/assets/images/headlines-logo.svg';

const professions = [
  'Clinical Nutritionists',
  'Dietitians',
  'Fitness and Health Coaches',
  'Mental Health Professionals'
] as const;

const separatorLogo = headlinesLogo;
const headlineLogo = headlinesLogo;

const ProfessionTicker = () => {
  const renderItems = (keyPrefix: string) => (
    <>
      <img src={headlineLogo} alt="" className={styles.headlineLogo} aria-hidden="true" />
      {professions.map((profession, index) => (
        <React.Fragment key={`${keyPrefix}-${profession}`}>
          <span className={styles.item}>{profession}</span>
          {index < professions.length - 1 && (
            <img src={separatorLogo} alt="" className={styles.separator} aria-hidden="true" />
          )}
        </React.Fragment>
      ))}
    </>
  );

  return (
    <div className={styles.tickerShell} aria-label="Nutrition professions">
      <div className={styles.tickerTrack}>
        <div className={styles.tickerGroup}>{renderItems('primary')}</div>
        <div className={styles.tickerGroup} aria-hidden="true">{renderItems('loop')}</div>
      </div>
    </div>
  );
};

export default ProfessionTicker;
